import axios from 'axios';


const baseURL = ( process.env.REACT_APP_API_MOD ==='DEV'
				? process.env.REACT_APP_API_URL_DEV
				: process.env.REACT_APP_API_URL_PROD);//  || process.env.REACT_APP_API_URL;

const api = axios.create({
	baseURL,
	withCredentials: true,
});

//api.defaults.headers.post['Content-Type'] = 'application/json';

export default api;

//axios.defaults.baseURL = 'http://127.0.0.1:3333/';
//axios.defaults.headers.post['Content-Type'] = 'application/json';
/*
	para passar um token para a api
	api.defaults.headers.authorization = `Bearer ${token}`;

	mais coisas aqui
	https://blog.rocketseat.com.br/axios-um-cliente-http-full-stack/
*/

/*
Agora é so usar no codigo
api.get("/...")
api.post("/...",,{...})
api.post("/...",,{...},[opções])
	essas opções fazem o post retornar algo, exemplo o progresso de um upload

api.post(...)
	.then(() => {
		// quando a requisição terminar de chegar/enviar
	})
	.cath(() => {
		// caso falhe
		error:true
	});
*/
